export const columns = [
    {
        field: 'id',
        header: 'Id',
        sizes: { xs: 1 }
    },
    {
        field: 'invoiceCode',
        header: 'Tipo',
        sizes: { xs: 1 }
    },
    {
        field: 'cashRegisterName',
        header: 'Cod. de factura'
    },
    {
        field: 'cashTypeOrigin',
        header: 'Origen'
    },
    {
        field: 'cashTypeDestination',
        header: 'Destino'
    },
    {
        field: 'amount',
        header: 'Total',
        type: 'money'
    },
    {
        field: 'created',
        header: 'Fecha de creación',
        type: 'date',
        sizes: { xs: 2 }
    },
    {
        field: 'userEmail',
        header: 'Usuario',
        sizes: { xs: 2 }
    }
]

export const title = 'Listado de comprobantes internos';

export const paymentMethodTypes = {
    Cash: 'Cash',
    Card: 'Card',
    Qr:'Qr',
    Posnet: 'Card'
}

export const paymentMethodTypesFormat = {
    Cash: 'Efectivo',
    Card: 'Tarjeta',
    Qr: 'Mercado Pago',
    Posnet: 'Tarjeta'
}

